import { render, staticRenderFns } from "./Comments_mobile.vue?vue&type=template&id=53564659&scoped=true&"
import script from "./Comments_mobile.vue?vue&type=script&lang=js&"
export * from "./Comments_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Comments_mobile.vue?vue&type=style&index=0&id=53564659&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53564659",
  null
  
)

export default component.exports